import React, { useContext, useEffect, useState }from 'react';
import { Link, useLocation, Redirect } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import logo from '../../assets/img/logo.png'
import Axios from 'axios';
import { apiRoutes } from '../../AppSettings';

const getFaviconEl = () => {
    return document.getElementById("favicon");
}

const Header = (props) => {
    const location = useLocation();
    let isLoginPage = location.pathname === "/"

    const {userState, resetUserState} = useContext(AuthContext);

    const [setting, setSetting] = useState({ logo:  logo,  favicon: '', websiteName: ''})

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() => {
        IsvalidToken();
        ApplySettings();
    }, []);

    const ApplySettings = () => {
        Axios.get(apiRoutes.LoadSetting, options)
        .then((response) => {

            if(response.status === 200)
            {
                const data = response.data;
                if(data.favicon != undefined)
                {
                    const favicon = getFaviconEl(); // Accessing favicon element
                    favicon.href = data.favicon;
                    setSetting({...setting, favicon: data.favicon});
                }

                if(data.logo != undefined)
                {
                    setSetting({...setting, logo: data.logo});
                }
            }
        }, (error) => {
          console.log(error.response);
        });
    }

    const IsvalidToken = () => {
        if(userState.token != undefined && userState.token != '')
        {
            Axios.get(apiRoutes.validateToken, options)
                .then((response) => {
                if(response.status === 200)
                {
                    return true;
                }
                }, (error) => {
                    console.log(error.response);
                    if(error.response.status == 401 && error.response.statusText == "Unauthorized")
                    {
                        resetUserState();                        
                        return <Redirect to={
                            {
                                pathname: "/",
                                state: {
                                    from: props.location
                                }
                            }
                        }/>
                    }
            });
        }
        return false;
    }
    
    
    return (
        <header className="header">
            <nav className="navbar navbar-expand-lg header-nav">
                <div className="navbar-header">
                    <a id="mobile_btn" href="javascript:void(0);">
                        <span className="bar-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </a>
                    <a href="index.html" className="navbar-brand logo">
                        <img src={setting.logo} style={{"height" : "70px"}} className="img-fluid" alt="Logo" />
                    </a>
                </div>
                <div className="main-menu-wrapper">
                    <div className="menu-header">
                        <a href="index.html" className="menu-logo">
                            <img src={setting.logo} className="img-fluid" alt="Logo" />
                        </a>
                        <a id="menu_close" className="menu-close" href="javascript:void(0);">
                            <i className="fas fa-times"></i>
                        </a>
                    </div>
                    <ul className="main-nav">
                    </ul>
                </div>
                <ul className="nav header-navbar-rht">
                    <li className="nav-item contact-item">
                        <div className="header-contact-img">
                            <i className="far fa-hospital"></i>
                        </div>
                        <div className="header-contact-detail">
                            <p className="contact-header">Contact</p>
                            <p className="contact-info-header"> +49 1515 1587387</p>
                        </div>
                    </li>
                    {
                        !userState.isAuthenticated && 
                        <li className="nav-item">
                            {/*<Link className="nav-link header-login" to={ isLoginPage ? '/register' : '/' }>login / Signup</Link>*/}
                        </li>
                    }
                </ul>
            </nav>
        </header>
    );
};


export default Header;